import { defineAsyncComponent } from "vue";

export default [
  {
    name: "AlsSessionViewCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AlsSessionViewEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AlsSessionViewSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "AlsSessionViewSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "section/:sectionId/end",
    props: true,
  },
  {
    name: "AlsSessionViewActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    path: "not-found",
    name: "AlsSessionViewNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
